import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const LogoutApi = {
  logout: async (userId) => {
    try {
      const response = await axiosInstance.post(Configs.logoutEp, {
        user_id: userId,
      });

      return response.data; // Return API response
    } catch (error) {
      console.error("Logout error:", error);
      return {
        status: "fail",
        message: `An error occurred: ${error.message}`,
      };
    }
  },
};

export default LogoutApi;
